import { Amplify } from 'aws-amplify';
import { events } from 'aws-amplify/data';
// Async
import { getQuizEvents } from 'store/quizEvents/quizEventsAsync';
// Actions
import { triggerQuizEvent } from 'store/quizEvents/quizEventsSlice';

// ===== MODULE STATE =====
let channel: any = null;
let subscription: any = null;

let reconnectTimer: any = null;
let currentConfig: any = null;
let lastDispatch: any = null;

const BASE_DELAY = 1000;   // 1s
const MAX_DELAY = 30000;  // 30s
let reconnectAttempts = 0;

// ===== HELPERS =====
const getDelay = () =>
  Math.min(BASE_DELAY * Math.pow(2, reconnectAttempts), MAX_DELAY);

const cleanup = () => {
  try {
    subscription?.unsubscribe();
  } catch {}
  subscription = null;
  channel = null;
};

// ===== CORE CONNECT =====
const connect = async () => {
  if (!currentConfig || channel) return;

  try {
    channel = await events.connect(`/quiz/${currentConfig.quizId}`);

    subscription = channel.subscribe({
      next: (data:any) => {
        reconnectAttempts = 0; // reset backoff

        const { quizId, id: eventId } = data.event.data;
        if (quizId === currentConfig.quizId) {
          lastDispatch(triggerQuizEvent(eventId));
        }
      },
      error: handleDisconnect,
      complete: handleDisconnect,
    });

    console.log('[AppSync] connected');

  } catch (err) {
    handleDisconnect(err);
  }
};

// ===== DISCONNECT HANDLER =====
const handleDisconnect = async (err?: any) => {
  console.warn('[AppSync] disconnected', err);

  cleanup();

  // STEP A: pull latest events from API
  if (lastDispatch && currentConfig?.quizId) {
    try {
      console.log('[AppSync] calling fallback API');
      lastDispatch(getQuizEvents(currentConfig.quizId));
    } catch (e) {
      console.error('[AppSync] failed to fetch fallback events', e);
    }
  }

  // STEP B: schedule reconnect
  reconnectAttempts += 1;
  const delay = getDelay();

  reconnectTimer = setTimeout(() => {
    console.log('[AppSync] reconnecting...');
    connect();
  }, delay);
};

// ===== MIDDLEWARE =====
const appSyncEventsMiddleware =
  ({ dispatch }: any) =>
  (next: any) =>
  async (action: any) => {
    const result = next(action);

    if (action.type === 'ui/setAppSyncEventsConfig') {
      currentConfig = action.payload;
      lastDispatch = dispatch;
      reconnectAttempts = 0;

      Amplify.configure({
        API: {
          Events: {
            endpoint: 'https://events-staging.quizwizards.com/event',
            defaultAuthMode: 'apiKey',
            apiKey: currentConfig.apiKey,
          },
        },
      });

      if (!channel) {
        connect();
      }
    }

    return result;
  };

export default appSyncEventsMiddleware;
